export const INPUT_TAGS = {
  execute: 'EXECUTE_HCAPTCHA_INVISIBLE',
  initialize: 'INITIALIZE_HCAPTCHA_INVISIBLE',
  sendFraudSignals: 'SEND_FRAUD_SIGNALS_HCAPTCHA_INVISIBLE',
} as const;
export const OUTPUT_TAGS = {
  response: 'RESPONSE_HCAPTCHA_INVISIBLE',
  error: 'ERROR_HCAPTCHA_INVISIBLE',
  load: 'LOAD_HCAPTCHA_INVISIBLE',
  sendComplete: 'SEND_COMPLETE_HCAPTCHA_INVISIBLE',
} as const;

export type InitializeHCaptchaInput = {
  tag: typeof INPUT_TAGS.initialize;
  message: {
    sitekey: string;
  };
};

export type ExecuteHCaptchaInput = {
  tag: typeof INPUT_TAGS.execute;
  message: {
    data: Record<string, string>;
    sitekey: string;
    rqdata?: string;
  };
};

export type EventType = 'mouse' | 'keyboard' | 'touch' | 'pointer';

export type EventName =
  | 'mousemove'
  | 'mousedown'
  | 'mouseup'
  | 'keydown'
  | 'keyup'
  | 'touchmove'
  | 'touchstart'
  | 'touchend'
  | 'pointermove'
  | 'pointerdown'
  | 'pointerup';

export type SendFraudSignalsHCaptchaInput = {
  tag: typeof INPUT_TAGS.sendFraudSignals;
  message: {
    type: EventType;
    eventName: EventName;
    coordinates?: {x: number; y: number};
  };
};

export type HCaptchaInvisibleInboundPayload =
  | InitializeHCaptchaInput
  | ExecuteHCaptchaInput
  | SendFraudSignalsHCaptchaInput;

export type HCaptchaResponseOutboundPayload = {
  tag: typeof OUTPUT_TAGS.response;
  value: {
    response: string;
    key: string;
    duration: number;
  };
};
export type HCaptchaErrorOutboundPayload = {
  tag: typeof OUTPUT_TAGS.error;
  value: {
    error: string;
  };
};
export type HCaptchaLoadOutboundPayload = {
  tag: typeof OUTPUT_TAGS.load;
};

export type HCaptchaSendCompleteOutboundPayload = {
  tag: typeof OUTPUT_TAGS.sendComplete;
};

export type HCaptchaInvisibleOutboundPayload =
  | HCaptchaResponseOutboundPayload
  | HCaptchaErrorOutboundPayload
  | HCaptchaLoadOutboundPayload
  | HCaptchaSendCompleteOutboundPayload;
